export default {
  advancePaid: 'അഡ്വാൻസ് അടച്ചു',
  assignedOperator: 'നിയോഗിച്ച ഓപ്പറേറ്റർ',
  availableNow: 'ഇപ്പോൾ ലഭ്യം',
  avgRating: 'ശരാശരി റേറ്റിംഗ്',
  bankTransferFailed: 'സമർപ്പണം പരാജയം.',
  bankTransferPendingHint: 'മുകളിലെ തുകയുടെ ബാങ്ക് ട്രാൻസ്ഫർ പൂർത്തിയാക്കിയ ശേഷം UTR സമർപ്പിക്കൂ.',
  bankTransferSubmitted: 'സമർപ്പിച്ചു. Admin verify-ന് ശേഷം wallet credit (സാധാരണ 24h).',
  bankTransferTitle: 'ബാങ്ക് ട്രാൻസ്ഫർ വിവരങ്ങൾ',
  bankTransferUnavailable: 'NEFT/IMPS കോൺഫിഗർ ചെയ്തിട്ടില്ല. Pay Now അല്ലെങ്കിൽ UPI QR.',
  bankUtrPlaceholder: 'UTR / reference (8–22 അക്ഷരം)',
  bf2Active: 'സജീവം',
  bf2ActualWorkRequired: 'യഥാർത്ഥ ജോലി സമയം (HH:MM:SS)',
  bf2AdvancePaid: 'അഡ്വാൻസ് അടച്ചു',
  bf2AwaitingDispatch: 'ബുക്കിംഗ് സ്ഥിരീകരിച്ചു. ഡിസ്പാച്ച് അംഗീകാരത്തിനായി കാത്തിരിക്കുന്നു.',
  bf2BalanceDue: 'ബാക്കി: ₹{amount} (വാലറ്റ്)',
  bf2Booked: 'ബുക്ക് ചെയ്തു',
  bf2CompletedHours: ' · {hours} മണി',
  bf2CompletedSummary: 'ആകെ: ₹{total} · അഡ്വാൻസ്: ₹{advance}',
  bf2ConfirmPayBtn: 'സ്ഥിരീകരിച്ച് ₹{amount} അടയ്ക്കൂ',
  bf2ConfirmWorkComplete: 'ജോലി പൂർത്തിയായി സ്ഥിരീകരിക്കൂ',
  bf2Deadline: 'അവസാന സമയം: {time} ബാക്കി',
  bf2Dispute: 'വിവാദം',
  bf2DisputePlaceholder: 'മണിക്കൂറുകൾ തെറ്റാണ് കാരണം...',
  bf2DisputeRaised: 'വിവാദം ഉയർത്തി. അഡ്മിൻ പരിശോധിക്കുന്നു.',
  bf2ExtendHr: '+ {hours}മണി നീട്ടൂ',
  bf2ExtensionPending: 'എക്സ്റ്റൻഷൻ അഭ്യർത്ഥിച്ചു. തുടരാൻ അഡ്വാൻസ് അടയ്ക്കൂ.',
  bf2LogWorkConfirm: '{time} ({hours} മണി) ബുക്കിംഗ് #{ref} ലോഗ് ചെയ്യണോ? ക്ലയന്റിനെ അറിയിക്കും.',
  bf2MachineHoursLive: 'മെഷീൻ മണിക്കൂറുകൾ (ലൈവ്)',
  bf2MarkCompleteFailed: 'പൂർത്തിയാക്കൽ അടയാളപ്പെടുത്തൽ പരാജയപ്പെട്ടു',
  etaOwnerApproval: 'ഉടമയുടെ അംഗീകാരത്തിനായി കാത്തിരിക്കുന്നു',
  etaWorkInProgress: 'അനുമാനിച്ച പൂർത്തീകരണം',
  etaPaymentDeadline: 'പേയ്‌മെന്റ് സ്ഥിരീകരണ അവസാന തീയതി',
  etaWorkCompleted: 'ജോലി പൂർത്തിയായി',
  etaDisputeReview: 'DE ടീം വിവാദം പരിശോധിക്കുന്നു',
  etaMinutesRemaining: '{n} മിനിറ്റ് ബാക്കി',
  etaHoursRemaining: '{n} മണി ബാക്കി',
  bf2MinimumBilling: 'കുറഞ്ഞത് {hours} മണി ബില്ലിംഗ് (₹{amount})',
  bf2OperatorLogged: 'ഓപ്പറേറ്റർ ലോഗ്: {logged} മണി · കുറഞ്ഞത്: {min} മണി · ചാർജ്: {final} മണി',
  bf2Outstanding: 'കുടിശ്ശിക',
  bf2OwnerApprovedSoon: 'ഉടമ അംഗീകരിച്ചു — മെഷീൻ ഉടൻ ആരംഭിക്കും.',
  bf2Remaining: 'ബാക്കി',
  bf2RunningBill: 'നടന്ന ബിൽ',
  bf2Started: 'ആരംഭിച്ചു',
  bf2SubmitDispute: 'വിവാദം സമർപ്പിക്കൂ',
  blacklistWarnBookingsCancelled: 'എല്ലാ ബുക്കിംഗുകളും റദ്ദാക്കും',
  blacklistWarnClientMachine: 'ക്ലയന്റും മെഷീനും ബ്ലാക്ക്‌ലിസ്റ്റ് ചെയ്യും',
  blacklistWarnLegalAction: 'നിയമനടപടി എടുക്കും',
  blacklistWarnWalletFrozen: 'വാലറ്റ് ബാലൻസ് മരവിപ്പിക്കും',
  bookingConfirmFailed: 'സ്ഥിരീകരണം പരാജയപ്പെട്ടു',
  bookingDisputeFailed: 'വിവാദം പരാജയപ്പെട്ടു',
  bookingExtensionFailed: 'എക്സ്റ്റൻഷൻ പരാജയപ്പെട്ടു',
  bookingFailedGeneric: 'ബുക്കിംഗ് പരാജയപ്പെട്ടു. വീണ്ടും ശ്രമിക്കൂ.',
  bookingTypeLabel: 'ബുക്കിംഗ് തരം',
  bookingsCount: '{count} ബുക്കിംഗുകൾ',
  closeMenuAria: 'മെനു അടയ്ക്കുക',
  confirmAdvanceLabel: 'അഡ്വാൻസ്',
  confirmPayBalancePrompt: 'ബാക്കി ₹{amount} സ്ഥിരീകരിച്ച് പേ ചെയ്യണോ?',
  confirmWalletAfterLabel: 'ശേഷിക്കുന്ന വാലറ്റ്',
  currentlyDeployed: 'നിലവിൽ ഡിപ്ലോയ്',
  daysUnit: 'ദിവസം',
  directContactBlacklist: 'നേരിട്ടുള്ള ബന്ധം = ബ്ലാക്ക്‌ലിസ്റ്റ്',
  dynamicUpiQrHint: '30 മിനിറ്റ് സാധുത. പേയ്‌മെന്റിന് ശേഷം വാലറ്റ് ഓട്ടോ credit.',
  dynamicUpiQrPrompt: 'തുക നൽകി ഒറ്റത്തവണ UPI QR സൃഷ്ടിക്കൂ.',
  dynamicUpiQrTitle: 'സ്കാൻ ചെയ്ത് പേ ചെയ്യൂ (Razorpay)',
  filterAll: 'എല്ലാം',
  filterCredit: 'ക്രെഡിറ്റ്',
  filterDebit: 'ഡെബിറ്റ്',
  fuelColon: 'ഇന്ധനം:',
  fuelHistoryTitle: 'ഇന്ധന ചരിത്രം',
  fuelNotePlaceholder: 'കുറിപ്പ്: നിറച്ച / ഉപയോഗിച്ച ഇന്ധനം...',
  fuelNoteRefilledPlaceholder: 'കുറിപ്പ്: 50 ലിറ്റർ നിറച്ചു...',
  generateUpiQr: 'UPI QR സൃഷ്ടിക്കൂ',
  gstInvoiceAfterComplete: 'GST invoice unlocks after booking is marked Completed.',
  hrsUnit: 'മണി',
  invoiceCol: 'ഇൻവോയ്സ്',
  invoiceNotAvailableCancelled: 'ഇൻവോയ്സ് ലഭ്യമല്ല (റദ്ദാക്കി)',
  issueDescribePlaceholder: 'സമസ്യ വിശദമായി വിവരിക്കൂ...',
  liveMachineLocation: 'ലൈവ് മെഷീൻ സ്ഥാനം',
  loadedOwnerBookings: '{count} ഉടമ ബുക്കിംഗ് ലോഡ്{suffix}',
  loginIAmQuestion: 'ഞാൻ ആരാണ്…?',
  loginPickRoleHint: 'രജിസ്റ്റർ ചെയ്തവരാണോ? റോൾ തിരഞ്ഞെടുക്കൂ. പുതിയവരാണോ? താഴെ Join Us.',
  loginPortalAdminSubtitle: 'പ്ലാറ്റ്‌ഫോം നിയന്ത്രണവും അംഗീകാരവും',
  loginPortalAdminTitle: 'അഡ്മിൻ പോർട്ടൽ',
  loginPortalClientSubtitle: 'നിർമ്മാണ മെഷിനറി ബുക്ക് ചെയ്യാൻ സൈൻ ഇൻ',
  loginPortalClientTitle: 'ക്ലയന്റ് പോർട്ടൽ',
  loginPortalOperatorSubtitle: 'നിയോഗിച്ച മെഷീനുകൾക്കും ലോഗിനും സൈൻ ഇൻ',
  loginPortalOperatorTitle: 'ഓപ്പറേറ്റർ പോർട്ടൽ',
  loginPortalOwnerSubtitle: 'ഫ്ലീറ്റും രജിസ്ട്രേഷും നിയന്ത്രിക്കാൻ സൈൻ ഇൻ',
  loginPortalOwnerTitle: 'ഉടമ പോർട്ടൽ',
  loginRoleAdminDesc: 'പ്ലാറ്റ്‌ഫോം നിയന്ത്രണം, അംഗീകാരങ്ങൾ',
  loginRoleClientDesc: 'നിർമ്മാണ പ്രോജക്റ്റുകൾക്ക് മെഷിനറി ബുക്ക് ചെയ്യൂ',
  loginRoleOperatorDesc: 'നിയോഗിച്ച മെഷീനുകളും ദൈനംദിന ലോഗും',
  loginRoleOwnerDesc: 'ഫ്ലീറ്റ്, വരുമാനം, ലഭ്യത നിയന്ത്രിക്കൂ',
  machineDefaultLabel: 'മെഷീൻ',
  machineDetailsTitle: 'മെഷീൻ വിശദാംശങ്ങൾ',
  machineDispatchedAt: 'മെഷീൻ അയച്ചു — {when}',
  machineIdLabel: 'മെഷീൻ ID',
  marketingBuiltFor: 'കൃത്യത, അനുസരണം, വേഗം വേണ്ട ഇന്ത്യൻ നിർമ്മാണ ടീമുകൾക്ക്.',
  minPasswordPlaceholder: 'കുറഞ്ഞത് 8 അക്ഷരങ്ങൾ',
  moUnit: 'മാസം',
  naLabel: 'ബാധകമല്ല',
  navigateToSite: '🗺️ Navigate to Site',
  noAlertsNow: 'ഇപ്പോൾ അലർട്ടുകളില്ല.',
  noBookingsAccount: 'ഈ അക്കൗണ്ടിൽ ഇതുവരെ ബുക്കിംഗുകളില്ല.',
  noTransactionsFilter: 'തിരഞ്ഞെടുത്ത ഫിൽട്ടറിന് ഇടപാടുകളില്ല.',
  openInMaps: '📍 Open in Maps',
  operatorFullNamePlaceholder: 'ഓപ്പറേറ്ററുടെ പൂർണ്ണ പേര്',
  ownerAccountHolderName: 'അക്കൗണ്ട് ഉടമയുടെ പേര്',
  ownerBankName: 'ബാങ്ക് പേര്',
  ownerBankTaxDetails: 'ബാങ്ക് & ടാക്സ് വിവരങ്ങൾ',
  ownerBankTaxHint: 'PDF രസീതിനും NEFT-നും ആവശ്യം. Account/PAN masked കാണും.',
  ownerBookingRef: 'ബുക്കിംഗ് Ref',
  ownerBookingsAllLoaded: ' (എല്ലാം ലോഡ്)',
  ownerBookingsMoreAvailable: ' (കൂടുതൽ ലഭ്യം)',
  ownerCancelEdit: 'റദ്ദാക്കുക',
  ownerEditProfile: 'എഡിറ്റ്',
  ownerMarkWorkComplete: 'Mark work complete',
  ownerNoPaymentsYet: 'ഇതുവരെ payment ഇല്ല',
  ownerPanNumber: 'PAN നമ്പർ',
  ownerPaymentPendingWallet: 'Net payout pending — DE treasury will credit your Payout Wallet shortly.',
  ownerPaymentReceivedBody: 'Gross billing ₹{gross} recorded. Net to your wallet: ₹{net}.',
  ownerPaymentReceivedTitle: 'Payment received',
  ownerPayoutCredit: 'ക്രെഡിറ്റ്',
  ownerPayoutDebit: 'ഡെബിറ്റ്',
  ownerPayoutHow1: 'ക്ലയന്റ് അഡ്വാൻസ് വേറെ Client Wallet-ിൽ.',
  ownerPayoutHow2: 'സെറ്റിൽമെന്റിന് ശേഷം Admin നിങ്ങളുടെ Payout Wallet credit ചെയ്യും.',
  ownerPayoutHow3: 'സബ്സ്ക്രിപ്ഷൻ (ഭാവി) — ഇതുവരെ build ഇല്ല.',
  ownerPayoutHowTitle: 'ഉടമ payout എങ്ങനെ',
  ownerPayoutTxnEmpty: 'ഇതുവരെ payout ഇല്ല. DE accounts-നെ ബന്ധപ്പെടുക.',
  ownerPayoutTxnTitle: 'പേഔട്ട് ലെഡ്ജർ',
  ownerPayoutWallet: 'പേഔട്ട് വാലറ്റ്',
  ownerPayoutWalletBalance: 'പേഔട്ട് വാലറ്റ് ബാലൻസ്',
  ownerPayoutWalletHint: 'DE-യിൽ നിന്നുള്ള വാടക/സെറ്റിൽമെന്റ് ഇവിടെ credit. Admin payout-ന് ശേഷം മാത്രം ബാലൻസ്.',
  ownerPendingSettlements: 'തീർപ്പാക്കാത്തത്',
  ownerProfileIncomplete: 'പ്രൊഫൈൽ അപൂർണ്ണം — രസീതിന് account-ൽ പേര് അപ്ഡേറ്റ് ചെയ്യൂ.',
  ownerProfileSaved: 'ബാങ്ക് & ടാക്സ് വിവരങ്ങൾ സേവ് ചെയ്തു.',
  ownerReceiptGenerating: 'തയ്യാറാക്കുന്നു…',
  ownerReceiptPdf: 'രസീത്',
  ownerRecentPayments: 'അടുത്തിടെയുള്ള Payments',
  ownerReportsDemoNotice: 'താഴെയുള്ള റിപ്പോർട്ട് ഡെമോ. യഥാർത്ഥ payout → Payout Wallet ടാബ്.',
  ownerSaveProfile: 'സേവ്',
  ownerSettings: 'Settings',
  ownerSettlementFailed: 'പരാജയം',
  ownerSettlementPending: 'ട്രാൻസ്ഫർ തീർപ്പാക്കാത്തത്',
  ownerSettlementSettled: 'Settled',
  ownerSettlementsEmpty: 'ഇതുവരെ settlement ഇല്ല. പൂർത്തിയായ ബുക്കിംഗിന് ശേഷം ഇവിടെ.',
  ownerSettlementsLoadError: 'ലോഡ് പരാജയം — വീണ്ടും ശ്രമിക്കൂ.',
  ownerThisMonth: 'ഈ മാസം',
  ownerTotalEarned: 'ആകെ നേടിയത്',
  ownerViewAllPayments: 'എല്ലാം കാണൂ',
  ownerWithdrawAmount: 'Amount (₹)',
  ownerWithdrawMin: 'Minimum ₹1,000',
  ownerWithdrawSubmit: 'Request withdraw',
  ownerWithdrawSubmitted: 'Withdraw request submitted. Paid after admin NEFT (1–3 days).',
  ownerWithdrawTitle: 'Withdraw to bank',
  ownerWorkCompleting: 'Completing…',
  pdfInvoiceFailed: 'ഇൻവോയ്സ് PDF തയ്യാറാക്കാനായില്ല. വീണ്ടും ശ്രമിക്കൂ.',
  pdfReportFailed: 'റിപ്പോർട്ട് PDF തയ്യാറാക്കാനായില്ല. വീണ്ടും ശ്രമിക്കൂ.',
  pendingCount: '{count} തീർപ്പാക്കാത്തത്',
  pleaseWait: 'ദയവായി കാത്തിരിക്കൂ…',
  policyLabel: 'നയം',
  policyTopicBooking: 'ബുക്കിംഗ്',
  policyTopicCancellation: 'റദ്ദാക്കൽ',
  policyTopicContact: 'ബന്ധം',
  policyTopicGst: 'GST',
  policyTopicHours: 'സപ്പോർട്ട് സമയം',
  processingLabel: 'പ്രോസസ്സ് ചെയ്യുന്നു…',
  pushBrowserBlocked: 'ബ്രൗസർ notifications ബ്ലോക്ക് ചെയ്തു. സൈറ്റ് settings-ൽ Allow ചെയ്ത് വീണ്ടും ON ചെയ്യൂ.',
  pushDisabledNote: 'ഓഫാണ് — ഈ ഉപകരണത്തിൽ പുഷ് അലർട്ട് ലഭിക്കില്ല.',
  pushEnabledNote: 'ഓണാണ് — ബ്രൗസർ permission ചോദിച്ചാൽ Allow ചെയ്യൂ.',
  pushEnablePrompt: 'തൽക്ഷണ അപ്ഡേറ്റുകൾക്ക് പുഷ് അറിയിപ്പുകൾ ഓണാക്കൂ',
  downloadDisputeStatement: 'തർക്ക പ്രസ്താവന ഡൗൺലോഡ് ചെയ്യുക',
  downloadInvoice: 'ഇൻവോയ്സ് ഡൗൺലോഡ് ചെയ്യുക',
  bookAgain: 'വീണ്ടും ബുക്ക് ചെയ്യുക',
  machineNoLongerAvailable: 'മെഷീൻ ഇപ്പോൾ ലഭ്യമല്ല',
  downloadHistoryPdf: 'ചരിത്രം PDF ഡൗൺലോഡ് ചെയ്യുക',
  pushMigrationRequired: 'DB migration ബാക്കി — Supabase-ൽ push_notifications migration run ചെയ്യുക.',
  pushNotificationsHint: 'ബുക്കിംഗ്, അപ്ഡേറ്റുകൾ — ബ്രൗസർ അലർട്ട്. WhatsApp വേറെ.',
  pushNotificationsTitle: 'പുഷ് അറിയിപ്പുകൾ',
  pushPrefLoadFailed: 'അറിയിപ്പ് preference ലോഡ് ചെയ്യാനായില്ല.',
  pushPrefUpdateFailed: 'അറിയിപ്പ് preference അപ്ഡേറ്റ് ചെയ്യാനായില്ല.',
  pushStatusOff: 'പുഷ് അറിയിപ്പുകൾ OFF',
  pushStatusOn: 'പുഷ് അറിയിപ്പുകൾ ON',
  quantityLabel: 'അളവ്',
  quickRechargeUpi: 'UPI വഴി പെട്ടെന്ന് റീചാർജ്',
  quickSelect: 'പെട്ടെന്ന് തിരഞ്ഞെടുക്കൂ:',
  razorpayMethodOpenHint: 'Razorpay checkout തുറക്കും',
  razorpayMethodsHint: 'Pay Now-ന് ശേഷം Razorpay checkout-ൽ:',
  recentLabel: 'അടുത്തിടെ',
  rechargeCustomPlaceholder: 'തുക (UPI/Card ₹1 മുതൽ)',
  rechargePlus: '+ റീചാർജ്',
  referenceQrTitle: 'റഫറൻസ് QR (ഓപ്ഷണൽ)',
  scanToPay: 'പേയ്‌മെന്റിന് സ്കാൻ ചെയ്യൂ',
  selectPaymentMethodHint: 'UPI/Card/Net Banking ₹1 മുതൽ. NEFT/IMPS കുറഞ്ഞത് ₹5,000.',
  sessionExpireWarning: '5 മിനിറ്റിൽ സെഷൻ അവസാനിക്കും. സജീവമായി ഇരിക്കൂ.',
  sessionExpiredLogin: 'സെഷൻ കാലഹരണപ്പെട്ടു! വീണ്ടും ലോഗിൻ ചെയ്യൂ.',
  signupCompanyName: 'കമ്പനി പേര്',
  signupContactName: 'ബന്ധപ്പെടാനുള്ള പേര്',
  signupCreatePassword: 'പാസ്‌വേഡ് സൃഷ്ടിക്കൂ',
  signupReenterPassword: 'പാസ്‌വേഡ് വീണ്ടും നൽകൂ',
  signupSectionCompany: 'കമ്പനി',
  signupSectionContact: 'നിങ്ങളുടെ വിവരങ്ങൾ',
  signupSectionSecurity: 'സുരക്ഷ',
  siteAddressLabel: 'സൈറ്റ് വിലാസം',
  siteGpsDenied: 'ലൊക്കേഷൻ permission നിഷേധിച്ചു. വിലാസം നേരിട്ട് നൽകൂ.',
  siteGpsLoading: 'സ്ഥാനം കണ്ടെത്തുന്നു…',
  siteGpsUnavailable: 'GPS ലഭ്യമല്ല. വിലാസം നേരിട്ട് നൽകൂ.',
  siteLocationOptional: 'ഓപ്ഷണൽ — ഓപ്പറേറ്റർ സൈറ്റ് വേഗം കണ്ടെത്താൻ സഹായിക്കും.',
  siteLocationTitle: 'സൈറ്റ് സ്ഥാനം',
  sitePincodeLabel: 'പിൻകോഡ്',
  statusCancelled: 'റദ്ദാക്കി',
  statusCompleted: 'പൂർത്തിയായി',
  submitBankTransfer: 'പരിശോധനയ്ക്ക് സമർപ്പിക്കൂ',
  supportPolicyBooking: 'വാലറ്റ്-മാത്രം അഡ്വാൻസ്. സൈറ്റിൽ പണം ഇല്ല.',
  supportPolicyCancellation: '1 മണി പിഴ; ബാക്കി വാലറ്റിൽ.',
  supportPolicyContact: 'DE Support മാത്രം — നേരിട്ട് ഓപ്പറേറ്റർ ബന്ധം നിരോധിച്ചിരിക്കുന്നു.',
  supportPolicyGst: 'എല്ലാ ഇൻവോയ്സിലും 18% GST; Reports ടാബിൽ നിന്ന് ഡൗൺലോഡ്.',
  supportPolicyHours: 'തിങ്ക–ശനി, 9–7 IST',
  tableBase: 'ബേസ്',
  tableGst: 'GST',
  timeLabel: 'സമയം',
  transactionsCount: '{count} ഇടപാടുകൾ',
  trustStatCompliant: 'അനുസരണ',
  trustStatMachines: 'മെഷീനുകൾ',
  trustStatRating: 'റേറ്റിംഗ്',
  txnDayNet: 'ദിവസ നെറ്റ്',
  txnDescription: 'വിവരണം',
  upiAppsHint: 'PhonePe | GPay | Paytm | BHIM',
  upiQrFailed: 'UPI QR പരാജയം. Card ടാബ് ഉപയോഗിക്കൂ.',
  upiQrNoAutoCredit: 'ഈ QR സ്കാൻ ചെയ്താൽ വാലറ്റ് credit ആവില്ല. Pay Now ഉപയോഗിക്കൂ.',
  upiQrNotEnabledOnMerchant: 'നിങ്ങളുടെ Razorpay-ൽ QR Codes പ്രവർത്തനരഹിതം.',
  upiQrSmallAmountHint: '₹1–10-ന് Card ടാബ് മികച്ചത്.',
  upiQrTabLabel: 'UPI QR',
  upiQrUseCardForSmallAmounts: '₹1–10 test-ന് Card ടാബ്.',
  useCurrentLocation: '📍 നിലവിലെ സ്ഥാനം ഉപയോഗിക്കൂ',
  walletCreditedAlert: '₹{amount} വാലറ്റിൽ ചേർത്തു!{payLine}',
  walletDebit: 'വാലറ്റ് ഡെബിറ്റ്',
  walletLoginRequired: 'സെഷൻ കാലഹരണപ്പെട്ടു. വീണ്ടും ലോഗിൻ ചെയ്യൂ.',
  walletLowRecharge: 'വാലറ്റ് ബാലൻസ് കുറവ് — അടുത്ത ബുക്കിംഗിന് മുമ്പ് റീചാർജ് ചെയ്യൂ',
  walletPaymentsBuildTag: 'Wallet payments v2',
  walletRechargeMinHint: '₹1 test: UPI QR fail ആണെങ്കിൽ Card. ബാങ്ക് കുറഞ്ഞത് ₹5,000.',
  walletRechargeRazorpayHint: 'Pay Now — Razorpay checkout-ന് ശേഷം വാലറ്റ് ഓട്ടോ credit. NEFT/IMPS ആപ്പിൽ ഇല്ല.',
  walletRechargeRazorpayTitle: 'വാലറ്റ് റീചാർജ്',
  walletRechargeRequired: 'വാലറ്റിൽ ₹{amount} വേണം. റീചാർജ് ചെയ്യൂ.',
  wksUnit: 'ആഴ്ച',
  yearsExperience: '{n} വർഷം',
};
